import React from 'react';
import { Navigate } from 'react-router-dom';

// 每個角色登入後的預設頁面
const ROLE_DEFAULT = {
  manager: '/products',
  purchasing: '/products',
  sales: '/quotes',
};

const ProtectedRoute = ({ element, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const userRaw = localStorage.getItem('user');

  // 未登入 → 導回登入頁
  if (!token || !userRaw) {
    return <Navigate to="/login" replace />;
  }

  let user;
  try {
    user = JSON.parse(userRaw);
  } catch {
    return <Navigate to="/login" replace />;
  }

  // 角色無權限 → 導回該角色的預設頁
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={ROLE_DEFAULT[user.role] || '/login'} replace />;
  }

  return element;
};

export default ProtectedRoute;
